const signMatchers = {
  '>': (a, b) => a > b,
  '>=': (a, b) => a >= b,
  '=': (a, b) => a === b,
  '*': () => true,
};

function splitVendorString(vendorString) {
  return vendorString.includes(' ') ? vendorString.split(' ') : [vendorString];
}

export function vendorsMatching(vendorString) {
  let [vendor, year] = splitVendorString(vendorString);
  const matcher = year ? matchNameAndYear : matchName;

  return (vendorsList = []) => {
    if (vendorsList.length === 0) {
      return true;
    }

    return matcher(vendorsList);
  };

  function matchName(vendorsList) {
    return vendorsList.some((rule) => {
      const [ruleVendor] = splitVendorString(rule);
      return vendor === ruleVendor;
    });
  }
  function matchNameAndYear(vendorsList) {
    // eslint-disable-next-line complexity
    return vendorsList.some((rule) => {
      let [ruleVendor, ruleSign, ruleYear] = splitVendorString(rule);
      if (ruleSign === undefined){
        ruleSign = '*';
      } else if (ruleYear === undefined) {
        ruleYear = ruleSign;
        ruleSign = '=';
      }
      const matcher = signMatchers[ruleSign] || (() => {
        console.error(`Unknown sign "${ruleSign}" at "${rule}"`);
        return false;
      });


      return vendor === ruleVendor && matcher(year, ruleYear);
    });
  }
}

